import { render, staticRenderFns } from "./MailRequest.vue?vue&type=template&id=87e73614&scoped=true"
import script from "./MailRequest.vue?vue&type=script&lang=js"
export * from "./MailRequest.vue?vue&type=script&lang=js"
import style0 from "./MailRequest.vue?vue&type=style&index=0&id=87e73614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e73614",
  null
  
)

export default component.exports